export default "__VITE_ASSET__BF$XjUbG__"